// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/app/components/rating/rating.component.scss */
.rating-container {
  display: flex;
  align-items: center;
  gap: 2px; /* Small gap between stars */
}
.rating-container ion-icon {
  font-size: 18px; /* Adjust size as needed */
  color: var(--ion-color-warning, #ffc409); /* Default star color, Ionic warning color */
  transition: transform 0.1s ease-in-out; /* Smooth hover effect */
}
.rating-container ion-icon.interactive {
  cursor: pointer;
}
.rating-container ion-icon.interactive:hover {
  transform: scale(1.1); /* Slightly enlarge on hover */
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-rating/app-rating.component.scss"],"names":[],"mappings":"AAAA,oDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA,EAAA,4BAAA;AACF;AACE;EACE,eAAA,EAAA,0BAAA;EACA,wCAAA,EAAA,4CAAA;EACA,sCAAA,EAAA,wBAAA;AACJ;AACI;EACE,eAAA;AACN;AACM;EACE,qBAAA,EAAA,8BAAA;AACR","sourcesContent":["/* src/app/components/rating/rating.component.scss */\n.rating-container {\n  display: flex;\n  align-items: center;\n  gap: 2px; /* Small gap between stars */\n\n  ion-icon {\n    font-size: 18px; /* Adjust size as needed */\n    color: var(--ion-color-warning, #ffc409); /* Default star color, Ionic warning color */\n    transition: transform 0.1s ease-in-out; /* Smooth hover effect */\n\n    &.interactive {\n      cursor: pointer;\n\n      &:hover {\n        transform: scale(1.1); /* Slightly enlarge on hover */\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
